import { genComponentEl } from '@/utils/utils';
import Component from './index.vue';

/**
 * 预览文件
 * @param {Object} data
 * @param {string} data.url
 */
export function previewFile(data) {
  genComponentEl(Component, data);
}
